const professionalDesignations = [
  'LICSW',
  'LCSW',
  'ACSW',
  'NCLEX',
  'PMHNP-BC',
  'FNP-BC',
  'LPC',
  'LMFT',
  'LCADAC',
  'Ph.D',
  'Psy.D',
  'CBT',
  'DBT',
  'PharmD',
  'LMHC',
  'MSW',
  'MMFT',
  'MS',
  'MA',
  'MEd',
  'LPC',
].map((item) => ({ title: item, value: item }))

export default professionalDesignations
